import React, { Component } from "react";
import { Navbar, Nav, NavDropdown, MenuItem } from "react-bootstrap";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import LoginAPI from "../api/LoginAPI";
import UserAPI from "../api/UserAPI";

import Login from "./Login";
import Users from "./Users";
import Groups from "./Groups";
import SwaggerView from "./SwaggerView";
import SwaggerEdit from "./SwaggerEdit";
import SwaggerDiff from "./SwaggerDiff";
import PrivateRoute from "./PrivateRoute";
import logo from "../logo.png";

import "../css/Navigation.css";

class Navigation extends Component {
  state = {
    isLogged: false
  };

  componentDidMount() {
    const access_token = localStorage.getItem("access_token");

    if (access_token === null) {
      localStorage.removeItem("access_token");
      return;
    }

    return UserAPI.getCurrentUser()
      .then(user => {
        localStorage.setItem("user", JSON.stringify(user));
        return UserAPI.getUserGroups(user.id);
      })
      .then(groups => {
        localStorage.setItem("groups", JSON.stringify(groups));
        this.setState({
          isLogged: !!access_token
        });
      })
      .catch(err => {
        // If the token is invalid delete the access_token 
        // and display the login form
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("access_token");
          this.setState({
            isLogged: false
          });
        }
      });
  }

  logout = () => {
    LoginAPI.logout().then(() => {
      localStorage.clear();
      this.setState({
        isLogged: false
      });
    });
  }

  login = () => {
    this.setState({
      isLogged: true
    });
  }

  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    const username = user ? user.username : "";

    // Creation of the different menus
    const anonymousMenu = (
      <Nav pullRight>
        <Navbar.Text><Link to="/login">Login</Link></Navbar.Text>
      </Nav>
    );

    const LogoutDropdown = (
      <NavDropdown id="dropdown" title={username}>
        <MenuItem href="#" onClick={this.logout}>Disconnect</MenuItem>
      </NavDropdown>
    )

    const adminMenu = (
      <Nav pullRight>
        <Navbar.Text><Link to="/users">Users</Link></Navbar.Text>
        <Navbar.Text><Link to="/groups">Groups</Link></Navbar.Text>
        <Navbar.Text><Link to="/swaggers">Swaggers</Link></Navbar.Text>
        {LogoutDropdown}
      </Nav>
    );
    const userMenu = (
      <Nav pullRight>
        <Navbar.Text><Link to="/swaggers">Swaggers</Link></Navbar.Text>
        {LogoutDropdown}
      </Nav>
    );

    let navigationMenu;
    if (localStorage.getItem("access_token")) {
      if (user && user.isAdmin) {
        navigationMenu = adminMenu;
      } else {
        navigationMenu = userMenu;
      }
    } else {
      navigationMenu = anonymousMenu;
    }

    return (
      <Router>
        <div>
          <Navbar className="navbar-fixed-top">
            <Navbar.Header>
              <Navbar.Brand>
                <div className="logo">
                  <img alt="logo" src={logo} />
                  <p className="logo-hub">HUB</p>
                </div>
              </Navbar.Brand>
            </Navbar.Header>
            {navigationMenu}
          </Navbar>

          <Route path={`${process.env.PUBLIC_URL}/login`}
            component={props => (
              <Login {...props} onLogin={this.login} />
            )} />

          <PrivateRoute path={`${process.env.PUBLIC_URL}/users`}
            component={Users} />

          <PrivateRoute path={`${process.env.PUBLIC_URL}/groups`}
            component={Groups} />

          <PrivateRoute path={`${process.env.PUBLIC_URL}/swaggers`}
            component={SwaggerView} />

          <PrivateRoute path={`${process.env.PUBLIC_URL}/swaggers-edit`}
            component={SwaggerEdit} />

          <PrivateRoute path={`${process.env.PUBLIC_URL}/swaggers-diff/:groupId/:swaggerId`}
            component={SwaggerDiff} />
        </div>
      </Router>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js